import React, { useState, useEffect } from 'react'
import { Card, Col, Row } from 'antd';
import TenantParameterUpdateForm from '../Forms/TenantParameterUpdateForm';
import RequestHandler from '../../util/RequestHandler';
import { BarsOutlined } from '@ant-design/icons';

const TenantParameter = () => {
  const [updateForm, setUpdateForm] = useState({ data: {}, loading: false });

  useEffect(() => {
    getUpdateFormData();
  }, [])

  const getUpdateFormData = () => {
    setUpdateForm({ ...updateForm, loading: true });
    RequestHandler.get("/TenantParameter/GetByTenant").then(response => {
      if (!response) {
        return setUpdateForm({ ...updateForm, loading: false });
      }

      setUpdateForm({ data: response, loading: false });
    })
  };

  const onSuccessUpdate = () => {
    getUpdateFormData();
  };

  return (
    <>
      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> FİRMA AYARLARI
          </p>
        </Col>
        <Col xs={8}>
        </Col>
      </Row>

      <Row className='gx-mt-3' justify='center'>
        <Col span={24}>
          <TenantParameterUpdateForm
            data={updateForm.data}
            loading={updateForm.loading}
            onSuccess={onSuccessUpdate}
          />
        </Col>
      </Row>
    </>
  )
}

export default TenantParameter;